import { useState } from "react";
import { onlineManager } from "@tanstack/react-query";

import AlertIcon from "@assets/icons/alert-icon.svg";
import OpenBoxIcon from "@assets/icons/open-box-icon.svg";

import { ERROR_MESSAGES, CONTACT_SUPPORT } from "@config/messages";
import { ImageSection } from "@components/Sections";
import { Paragraph } from "@ui/Content";
import { Spinner } from "@ui/Loaders";
import { Button } from "@ui/Button";
import { H3 } from "@ui/Headings";

interface Props {
  isVisible: boolean;
}

export default function ConnectionIssueScreen({ isVisible }: Props) {
  const [isPending, setIspending] = useState(false);

  const handleTryAgain = async () => {
    setIspending(true);
    onlineManager.setOnline(navigator.onLine);

    setTimeout(() => {
      setIspending(false);
    }, 1000);
  };

  const animationClass = isVisible ? "animate-fade-in" : "animate-fade-out";

  return (
    <div className={`flex flex-col ${animationClass}`}>
      <div className="flex flex-col justify-center items-center pt-[64px] pb-[30px] px-4">
        <ImageSection
          mainIcon={<OpenBoxIcon className="z-20" />}
          overlayIcon={<AlertIcon className="text-yellow-500" />}
          overlayIconBackground="bg-yellow-100"
        />

        <H3 className="text-yellow-600 dark:text-yellow-600 my-[19px]">Connection Issue</H3>

        <div className="flex flex-col gap-4 pt-[32px] pb-6 px-4 border-t dark:border-gray-700">
          <Paragraph>{ERROR_MESSAGES.CONNECTION_LOST}</Paragraph>
          <Paragraph>{CONTACT_SUPPORT}</Paragraph>
        </div>

        <Button className="min-w-[270px]" buttonType={"PRIMARY"} onClick={handleTryAgain}>
          {isPending ? <Spinner size={20} /> : "Try Again"}
        </Button>
      </div>
    </div>
  );
}
